<app-loader
	[enableCircle]="true"
	[isActive]="isLoading.value$ | async"
	[isAfterViewInit]="false"
></app-loader>
<h1 matDialogTitle>
	<div class="flex flex-row items-center justify-start gap-2">
		<div class="flex flex-col">
			<div>{{ 'time.update' | translate }}</div>
			<div
				*ngIf="isPastTime"
				class="text-warn text-sm"
			>
				{{ 'comego.isPastTimeUpdate' | translate }}
			</div>
		</div>
		<div class="flex-auto"></div>
		<div class="flex items-center space-x-2">
			<button
				(click)="delete(confirmDeleteDialog)"
				[disabled]="isLoading.value$ | async"
				*ngIf="canDelete$ | async"
				color="warn"
				mat-stroked-button
				tabindex="-1"
			>
				<span translate>utils.delete</span>
			</button>
			<button
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</h1>
<mat-dialog-content
	cdkTrapFocus
	class="!overflow-y-auto !max-h-[calc(100vh-200px)]"
>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		*ngIf="this.group as grp"
		class="flex flex-col"
	>
		<div class="flex flex-row gap-2">
			<div class="flex flex-auto flex-col items-stretch justify-start gap-2 lg:wflex-[1_0_440px]">
				<div
					(click)="!recording && $event.preventDefault(); !recording && openUserPicker()"
					[ngClass]="recording ? '' : 'cursor-pointer'"
					*ngIf="workspace$canManageOthers.value$ | async"
					class="flex w-full flex-col"
				>
					<mat-form-field
						[ngClass]="{ 'opacity-50': recording }"
						appearance="standard"
						class="form-control-interactive mat-form-field-no-label"
					>
						<div
							*ngIf="groupValue.user as user"
							class="-mb-16px flex items-center space-x-1.5"
						>
							<app-user-avatar
								[userId]="user.id"
								class="rounded-full"
								size="40px"
							></app-user-avatar>
							<div class="flex flex-auto flex-col leading-none pl-1"><span>{{ user.name }}</span></div>
							<button
								(click)="$event.preventDefault(); $event.stopPropagation(); patchValue({ user: null })"
								*ngIf="(postDiffUser$ | async) && !recording"
								mat-icon-button
								type="button"
							>
								<mat-icon>clear</mat-icon>
							</button>
						</div>
						<input
							[disabled]="recording"
							[value]="groupValue.user"
							class="!pointer-events-none"
							matInput
							readonly
						>
					</mat-form-field>
				</div>
				<div
					(click)="!(group.controls.date?.disabled || recording) && $event.preventDefault(); !(group.controls.date?.disabled || recording) && openCalPicker()"
					[ngClass]="(group.controls.date?.disabled || recording) ? '' : 'cursor-pointer'"
					class="flex w-full flex-col"
				>
					<mat-form-field
						[ngClass]="{ 'opacity-50': recording }"
						appearance="standard"
						class="pointer-events-none"
					>
						<mat-icon
							class="text-muted prefix-icon leading-none"
							matPrefix
							>calendar_month</mat-icon
						>
						<input
							[disabled]="group.disabled || group.controls.date?.disabled || recording"
							[value]="groupValue.date | formatDate"
							class="!pointer-events-none"
							matInput
						>
					</mat-form-field>
				</div>
			</div>
		</div>
		<div class="mat-bd-5 -mx-2 flex flex-col rounded-lg px-4 pt-3 pb-3">
			<div class="xs:mb-4 mb-0 flex">
				<div class="flex flex-grow flex-col">
					<div class="flex flex-col">
						<ng-container *ngIf="duration$ | async as dur">
							<div class="flex flex-col space-y-0.5">
								<span class="text-muted mat-typography">
									{{ 'comego.types.' + dur.typeName | translate }}:
									{{ dur.sum | parseMsAsDuration: false }}</span
								>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="flex flex-row items-center gap-2">
					<button
						(click)="this.comegoDescriptionToggle$.update(!this.comegoDescriptionToggle$.value)"
						[matTooltip]="'comego.toggleDescription' | translate"
						class="!h-6 !w-6 !flex !items-center !justify-center"
						mat-icon-button
						type="button"
					>
						<mat-icon class="!leading-none">{{
							this.comegoDescriptionToggle$.value ? 'comment' : 'comments_disabled'
						}}</mat-icon>
					</button>
				</div>
			</div>
			<div
				*ngIf="{ range: (groupError$ | async)?.range } as err"
				class="flex flex-col xs:mt-2 mt-0 gap-2"
			>
				@if (recording && (recording$ | async); as rec) {
				<div class="flex flex-row items-start space-x-2">
					<!-- Icon (always visible on left) -->
					<div
						[ngClass]="
              groupValue.type === 'work'
                ? 'size-6  p-0 leading-6  border  border-green-400  bg-green-600/90  dark:bg-green-600/60  text-green-200'
                : groupValue.type === 'absence'
                  ? 'size-6 p-0 leading-6  border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
                  : 'size-6  p-0 leading-6  dark:bg-neutral-600 bg-neutral-600/80'
            "
						*ngIf="calcIcon(iconMap[groupValue.type]) as type"
						class="mt-5 flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
					>
						<mat-icon
							class="text-center"
							inline
						>
							{{ type }}
						</mat-icon>
					</div>

					<!-- Center flexbox: contains type/time row + description row -->
					<div class="flex flex-auto flex-col space-y-2">
						<!-- Type and Time inputs row -->
						<div class="flex flex-col space-y-0 xs:flex-row xs:space-x-2 xs:gap-2">
							<!-- Type selector -->
							<mat-form-field
								appearance="standard"
								class="group min-w-0 flex-1 pt-0.5"
							>
								<mat-label
									class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
									>{{
										'comego.type' | translate
									}}</mat-label
								>
								<mat-select
									disabled
									formControlName="type"
								>
									<mat-select-trigger [ngSwitch]="groupValue.type">
										<ng-container *ngSwitchCase="'work'">{{
											'comego.types.work' | translate
										}}</ng-container>
										<ng-container *ngSwitchCase="'pause'">{{
											'comego.types.pause' | translate
										}}</ng-container>
									</mat-select-trigger>
									<mat-option value="work">
										<div class="flex flex-row items-center gap-2">
											<div
												class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200"
											>
												<mat-icon
													class="text-center mr-0"
													inline
													style="margin-right: 0px"
												>
													work_history
												</mat-icon>
											</div>
											<div>{{ 'comego.types.work' | translate }}</div>
										</div>
									</mat-option>
									<mat-option value="pause">
										<div class="flex flex-row items-center gap-2">
											<div
												class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 dark:bg-neutral-600 bg-neutral-600/80"
											>
												<mat-icon
													class="text-center mr-0"
													inline
													style="margin-right: 0px"
												>
													pause
												</mat-icon>
											</div>
											<div>{{ 'comego.types.pause' | translate }}</div>
										</div>
									</mat-option>
								</mat-select>
							</mat-form-field>

							<!-- Time inputs -->
							<div class="time-inputs-row flex min-w-0 items-center justify-between">
								<div [ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'">
									<app-time-input
										(click)="$event.stopPropagation(); this.selectInput($event, startInpRef)"
										(focus)="this.selectInput($event, startInpRef)"
										(keydown.enter)="$event.preventDefault()"
										[displayFormat]="false"
										[inputPlaceholder]="'timer.time.start' | translate"
										[maxlength]="5"
										#startInpRef="nativeElement"
										#tStartFormField
										elementRef
										formControlName="start"
										matInput
									>
										<ng-template
											let-control="control"
											let-inputPlaceholder="inputPlaceholder"
											timeInputControl
										>
											<mat-form-field
												appearance="standard"
												class="group"
												fxFill
											>
												<mat-label
													class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
													>{{
														inputPlaceholder
													}}</mat-label
												>
												<input
													[formControl]="control"
													[placeholder]="inputPlaceholder"
													matInput
													type="text"
												>
											</mat-form-field>
										</ng-template>
									</app-time-input>
								</div>
								<span class="tg-seperator mx-2 flex-shrink-0 text-center font-bold -mt-3"> - </span>
								<!-- Recording indicator -->
								<div
									[ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'"
									class="flex items-center justify-start text-red-500 animate-pulse -mt-2"
								>
									<mat-icon class="!text-md !mt-[0.2rem] placeholder:leading-none"
										>fiber_manual_record</mat-icon
									>
									<span class="text-md font-medium uppercase -ml-[0.6rem]">rec</span>
								</div>
							</div>
						</div>

						<!-- Description field (always full-width in its own row) -->
						<ng-container *ngIf="this.comegoDescriptionToggle$.value && groupValue.type != 'pause'">
							<mat-form-field
								*ngIf="{ error: getErrorObservable('name') | async } as ctrl"
								appearance="standard"
								class="w-full description-field"
							>
								<input
									cdkInitialFocus
									class="text-black/60 dark:text-white/70"
									formControlName="name"
									matInput
									placeholder="{{ 'Description' | translate }}"
									type="text"
								>
								<mat-error *ngIf="ctrl.error as error">{{
									error.content | translate: (error.args | translateArgs)
								}}</mat-error>
								<mat-hint class="w-full text-right"
									>{{ groupValue.name?.length ?? 0 }}/ {{ maxLength }}</mat-hint
								>
							</mat-form-field>
						</ng-container>
					</div>
				</div>
				} @else {
				<div class="flex flex-row items-start space-x-2">
					<!-- Icon (always visible on left) -->
					<div
						[ngClass]="
              groupValue.type === 'work'
                ? 'size-6  p-0 leading-6  border  border-green-400  bg-green-600/90  dark:bg-green-600/60  text-green-200'
                : groupValue.type === 'absence'
                  ? 'size-6 p-0 leading-6  border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
                  : groupValue.type === 'pause'
                    ? 'size-6  p-0 leading-6  dark:bg-neutral-600 bg-neutral-600/80'
                    : 'size-6  p-0 leading-6  border  border-violet-400  bg-violet-800/90  dark:bg-violet-800/60  text-violet-100'
            "
						*ngIf="calcIcon(iconMap[groupValue.type]) as type"
						class="mt-5 flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
					>
						<mat-icon
							class="text-center"
							inline
						>
							{{ type }}
						</mat-icon>
					</div>

					<!-- Center flexbox: contains type/time row + description row -->
					<div class="flex flex-auto flex-col space-y-2">
						<!-- Type and Time inputs row -->
						<div class="flex flex-col space-y-0 xs:flex-row xs:space-x-2 xs:gap-2">
							<!-- Type selector -->
							<mat-form-field
								appearance="standard"
								class="group min-w-0 flex-1 pt-0.5"
							>
								<mat-label
									class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
									>{{
										'comego.type' | translate
									}}</mat-label
								>
								<mat-select formControlName="type">
									<mat-select-trigger>
										<ng-container [ngSwitch]="groupValue.type">
											<ng-container *ngSwitchCase="'work'">{{
												'comego.types.work' | translate
											}}</ng-container>
											<ng-container *ngSwitchCase="'pause'">{{
												'comego.types.pause' | translate
											}}</ng-container>
											<ng-container *ngSwitchCase="'absence'">{{
												'comego.types.absence' | translate
											}}</ng-container>
											<ng-container *ngSwitchDefault>
												<ng-container *ngFor="let sub of absenceSubcategories">
													<ng-container *ngIf="sub.id === groupValue.type">{{
														sub | absenceTranslate
													}}</ng-container>
												</ng-container>
											</ng-container>
										</ng-container>
									</mat-select-trigger>

									<!-- Options -->
									<mat-option
										*ngIf="!(isSubAbsence | async)"
										value="work"
									>
										<div class="flex flex-row items-center gap-2">
											<div
												class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200"
											>
												<mat-icon
													class="text-center mr-0"
													inline
													style="margin-right: 0px"
												>
													work_history
												</mat-icon>
											</div>
											<div>{{ 'comego.types.work' | translate }}</div>
										</div>
									</mat-option>
									<mat-option
										*ngIf="!(isSubAbsence | async)"
										value="pause"
									>
										<div class="flex flex-row items-center gap-2">
											<div
												class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 dark:bg-neutral-600 bg-neutral-600/80"
											>
												<mat-icon
													class="text-center mr-0"
													inline
													style="margin-right: 0px"
												>
													pause
												</mat-icon>
											</div>
											<div>{{ 'comego.types.pause' | translate }}</div>
										</div>
									</mat-option>
									<ng-container *ngIf="!absenceSubcategories || absenceSubcategories.length === 0">
										<mat-option
											[style.display]="!(isSubAbsence | async) ? 'none' : ''"
											value="absence"
										>
											<div class="flex flex-row items-center gap-2">
												<div
													class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
												>
													<mat-icon
														class="text-center mr-0"
														inline
														style="margin-right: 0px"
													>
														beach_access
													</mat-icon>
												</div>
												<div>{{ 'comego.types.absence' | translate }}</div>
											</div>
										</mat-option>
									</ng-container>
									<ng-container *ngIf="absenceSubcategories?.length && isSubAbsence | async">
										<mat-optgroup [label]="'workspace.absence-subcategories.title' | translate">
											<mat-option
												[style.display]="absencesForUser(subcategory, groupValue) ? '' : 'none'"
												[value]="subcategory.id"
												*ngFor="let subcategory of absenceSubcategories"
											>
												<div class="flex flex-row items-center gap-2">
													<div
														class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100 p-0 leading-6 border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100"
													>
														<mat-icon
															class="text-center mr-0"
															inline
															style="margin-right: 0px"
														>
															beach_access
														</mat-icon>
													</div>
													<div>{{ subcategory | absenceTranslate }}</div>
												</div>
											</mat-option>
										</mat-optgroup>
									</ng-container>
								</mat-select>
							</mat-form-field>

							<!-- Time inputs -->
							<div class="time-inputs-row flex min-w-0 items-center justify-between">
								<div [ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'">
									<app-time-input
										(click)="$event.stopPropagation(); this.selectInput($event, startInpRef)"
										(focus)="this.selectInput($event, startInpRef)"
										(keydown.enter)="$event.preventDefault()"
										[displayFormat]="false"
										[inputPlaceholder]="'timer.time.start' | translate"
										[maxlength]="5"
										#startInpRef="nativeElement"
										#tStartFormField
										elementRef
										formControlName="start"
										matInput
									>
										<ng-template
											let-control="control"
											let-inputPlaceholder="inputPlaceholder"
											timeInputControl
										>
											<mat-form-field
												appearance="standard"
												class="group"
												fxFill
											>
												<mat-label
													class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
													>{{
														inputPlaceholder
													}}</mat-label
												>
												<input
													[formControl]="control"
													[placeholder]="inputPlaceholder"
													matInput
													type="text"
												>
												<mat-error *ngIf="err.range">&nbsp;</mat-error>
											</mat-form-field>
										</ng-template>
									</app-time-input>
								</div>
								<span class="tg-seperator mx-2 flex-shrink-0 text-center font-bold -mt-3"> - </span>
								<div [ngClass]="(isAMPM$ | async) ? 'w-[72px] min-w-[72px]' : 'w-[48px] min-w-[48px]'">
									<app-time-input
										(click)="$event.stopPropagation(); this.selectInput($event, endInpRef)"
										(focus)="this.selectInput($event, endInpRef)"
										(keydown.enter)="$event.preventDefault()"
										[displayFormat]="false"
										[inputPlaceholder]="'timer.time.end' | translate"
										[maxlength]="5"
										#endInpRef="nativeElement"
										#tEndFormField
										elementRef
										formControlName="end"
										matInput
									>
										<ng-template
											let-control="control"
											let-inputPlaceholder="inputPlaceholder"
											timeInputControl
										>
											<mat-form-field
												appearance="standard"
												class="group"
												fxFill
											>
												<mat-label
													class="hidden xs:inline xs:opacity-0 xs:transition-opacity xs:group-hover:opacity-100"
													>{{
														inputPlaceholder
													}}</mat-label
												>
												<input
													[formControl]="control"
													[placeholder]="inputPlaceholder"
													matInput
													type="text"
												>
												<mat-hint *ngIf="duration$ | async as duration">{{
													duration | parseMsAsDuration: false
												}}</mat-hint>
												<mat-error *ngIf="err.range">&nbsp;</mat-error>
											</mat-form-field>
										</ng-template>
									</app-time-input>
								</div>
							</div>
						</div>

						<!-- Description field (always full-width in its own row) -->
						<ng-container *ngIf="this.comegoDescriptionToggle$.value && groupValue.type != 'pause'">
							<mat-form-field
								*ngIf="{ error: getErrorObservable('name') | async } as ctrl"
								appearance="standard"
								class="w-full description-field"
							>
								<input
									class="text-black/60 dark:text-white/70"
									formControlName="name"
									matInput
									placeholder="{{ 'Description' | translate }}"
									type="text"
								>
								<mat-error *ngIf="ctrl.error as error">{{
									error.content | translate: (error.args | translateArgs)
								}}</mat-error>
								<mat-hint class="w-full text-right"
									>{{ groupValue.name?.length ?? 0 }}/ {{ maxLength }}</mat-hint
								>
							</mat-form-field>
						</ng-container>
					</div>
				</div>
				<div
					*ngIf="err.range as error"
					class="text-warn -mt-2 ml-8"
				>
					{{ error.content | translate }}
				</div>
				}
			</div>
		</div>
	</form>
	<ng-container
		*ngIf="{
      times: !recording && workingHoursError$ | async,
      manual: error$disabled | async,
    } as error"
	>
		<div class="inset-x-0 my-4">
			<div
				[ngClass]="{
          'alert-danger': !err.type,
          'alert-info': err.type === 'info',
        }"
				*ngIf="error.manual as err"
				class="alert alert-tight rounded py-2"
			>
				{{ err.message | translate: (err.args | translateArgs) }}
			</div>
		</div>
		<ng-container *ngIf="!error.manual && error.times as err">
			<div class="inset-x-0 my-4">
				<div
					[ngClass]="{
            'alert-danger': !err.type,
            'alert-info': err.type === 'info',
          }"
					class="alert alert-tight rounded py-2"
				>
					{{ err.content | translate: (err.args || {} | translateArgs) }}
				</div>
			</div>
		</ng-container>
	</ng-container>
	<ng-container *ngIf="getErrorObservable('date') | async as error">
		<ng-container *ngIf="error as br">
			<div class="inset-x-0 my-4">
				<div class="alert alert-danger alert-tight rounded py-2">
					{{ br.content | translate: (br.args || {} | translateArgs) }}
				</div>
			</div>
		</ng-container>
	</ng-container>
</mat-dialog-content>
<mat-dialog-actions class="mat-action-filled">
	@if (recording) {
	<button
		(click)="submit()"
		[color]="recording ? 'warn' : 'primary'"
		[disabled]="group.invalid || (error$.value$ | async)"
		class="mat-action-filled"
		mat-flat-button
		type="button"
	>
		{{ 'comego.check_out' | translate }}
	</button>
	} @else {
	<button
		(click)="submit()"
		[color]="recording ? 'warn' : 'primary'"
		[disabled]="group.invalid || (error$.value$ | async) || (workingHoursError$ | async)"
		class="mat-action-filled"
		mat-flat-button
		type="button"
	>
		{{ (recording ? 'comego.check_out' : 'time.update') | translate }}
	</button>
	}
</mat-dialog-actions>
<ng-template
	#confirmDeleteDialog
	let-data="dialogData"
	let-ref="dialogRef"
>
	<div
		class="mat-dialog-title-base flex flex-col"
		matDialogTitle
	>
		<h4 class="my-0">{{ 'utils.confirmDeletion' | translate }}</h4>
	</div>
	<mat-dialog-content> <p>{{ 'comego.confirmDelete' | translate }}</p> </mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="ref.close(false)"
			mat-stroked-button
		>
			{{ 'utils.cancel' | translate }}
		</button>
		<button
			(click)="ref.close(true)"
			color="warn"
			mat-stroked-button
		>
			{{ 'utils.delete' | translate }}
		</button>
	</mat-dialog-actions>
</ng-template>
